// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nav-dropdown__widgets--alone .github-widget{display:grid;grid-template-columns:repeat(3,minmax(160px,1fr));grid-column-gap:32px}@media (max-width:1199px){.nav-dropdown__widgets--alone .github-widget{grid-template-columns:repeat(2,1fr)}}", ""]);
// Exports
module.exports = exports;
